import React from "react";

/* eslint-disable jsx-a11y/alt-text */
export const ColumnDefs = [
    {
        headerName: 'CategoryId',
        field: 'category_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Name',
        field: 'name',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Prefix 1',
        field: 'prefix',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Prefix 2',
        field: 'sku_no',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: '# of Subcategories',
        field: '_count',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    }
];

export const SubCategoryColumnDef = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 60,
        minWidth: 60
    },
    {
        headerName: 'CategoryId',
        field: 'category_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'ParentId',
        field: 'parent_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Subcategory',
        field: 'name',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Category',
        field: 'parent',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        cellRenderer: (params) => {
            return (
                <span>{params?.data?.parent?.name}</span>
            );
        },
    },
    {
        headerName: 'Prefix 3',
        field: 'prefix',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Prefix 4',
        field: 'sku_no',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: '# Of Products',
        field: 'productcount',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        cellRenderer: (params) => {
            return (
                <span>{params?.data?.["_count"]?.sub_cat_product}</span>
            );
        },
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    }
];

export const ProdColumnDefs = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 60,
        minWidth: 60
    },
    {
        headerName: 'ProductId',
        field: 'product_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Updated By',
        field: 'created_by',
        minWidth: 160,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Image',
        field: 'images',
        minWidth: 160,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Category',
        field: 'category',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Subcategory',
        field: 'sub_category',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Description',
        field: 'Description',
        minWidth: 250,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Manufacturer',
        field: 'manufacturer',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Vendor',
        field: 'vendor',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Model',
        field: 'model',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Catalog #',
        field: 'catalog',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Numeric ID',
        field: 'bixpand_id',
        minWidth: 220,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Alphanumeric ID',
        field: 'cad_id',
        minWidth: 270,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Custom ID 1',
        field: 'custom_id_1',
        minWidth: 220,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Custom ID 2',
        field: 'custom_id_2',
        minWidth: 270,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Govt. ID',
        field: 'govt_id',
        minWidth: 270,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'List Price',
        field: 'list_price',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Long Description',
        field: 'description',
        minWidth: 300,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Notes',
        field: 'notes',
        minWidth: 300,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Discontinued',
        field: 'discontinued',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Type',
        field: 'type',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Furnish Responsibility',
        field: 'furnish_responsibility',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Install Responsibility',
        field: 'install_responsibility',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Life Expectancy / Lifespan',
        field: 'life_expectancy',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Lead Time',
        field: 'lead_time',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Architectural Code',
        field: 'architectural_code',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Alternate ID',
        field: 'alternate_id',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Inventory ID',
        field: 'inventory_id',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Architecturally Significant',
        field: 'architecturally_significant',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Spatially Significant',
        field: 'spatially_significant',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Units',
        field: 'units',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Width',
        field: 'width',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Height',
        field: 'height',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Depth',
        field: 'depth',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Clearance - Left',
        field: 'clearance',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-left'
    },
    {
        headerName: 'Clearance - Right',
        field: 'clearance_right',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-right'
    },
    {
        headerName: 'Clearance - Back',
        field: 'clearance_back',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-back'
    },
    {
        headerName: 'Clearance - Front',
        field: 'clearance_front',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-front'
    },
    {
        headerName: 'Clearance - Top',
        field: 'clearance_top',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-top'
    },
    {
        headerName: 'Clearance - Bottom',
        field: 'clearance_bottom',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-bottom'
    },
    {
        headerName: 'Mouting',
        field: 'mouting',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Max Weight',
        field: 'max_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Ship Weight',
        field: 'ship_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Operating Weight',
        field: 'operating_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'DA Complient',
        field: 'da_complient',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Antimicrobial',
        field: 'antimicrobial',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Green',
        field: 'green',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Shielding',
        field: 'Shielding',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Seismic',
        field: 'seismic',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Spatial Remarks',
        field: 'spatial_remarks',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Voltage Type',
        field: 'electrical_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'voltage_type'
    },
    {
        headerName: 'Volts',
        field: 'volts',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        colId: 'volts',
        sortable: false,
    },
    {
        headerName: 'Amps',
        field: 'amps',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'amps'
    },
    {
        headerName: 'Watts',
        field: 'watts',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'watts'
    },
    {
        headerName: 'kVA',
        field: 'kva',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'kva'
    },
    {
        headerName: 'Hertz',
        field: 'hertz',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'hertz'
    },
    {
        headerName: 'Electric Phase',
        field: 'electric_phase',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'electric_phase'
    },
    {
        headerName: 'Plug Type',
        field: 'plug_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plug_type'
    },
    {
        headerName: 'Plug Details',
        field: 'plug_details',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plug_details'
    },
    {
        headerName: 'Emergency Power',
        field: 'emergency_power',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'emergency_power'
    },
    {
        headerName: 'Remote Transformer',
        field: 'remote_transformer',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'remote_transformer'
    },
    {
        headerName: 'Remote Switch / Controller',
        field: 'remote_switch',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'remote_switch'
    },
    {
        headerName: 'Electrical Remarks',
        field: 'electrical_remark',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'electrical_remark'
    },
    {
        headerName: 'Tech Connection',
        field: 'tech_connection_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'tech_connection'
    },
    {
        headerName: 'Connection Type',
        field: 'connection_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'connection_type'
    },
    {
        headerName: 'Network',
        field: 'network',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'network'
    },
    {
        headerName: 'Technical Remarks',
        field: 'technical_remarks',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'technical_remarks'
    },
    {
        headerName: 'Water Cold',
        field: 'plumbing_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'cold'
    },
    {
        headerName: 'Water Hot',
        field: 'hot',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'hot'
    },
    {
        headerName: 'Water Treated',
        field: 'treated',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'treated'
    },
    {
        headerName: 'Steam',
        field: 'steam',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'steam'
    },
    {
        headerName: 'Medical Vaccum',
        field: 'medical_vaccum',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'medical_vaccum'
    },
    {
        headerName: 'Dental Vaccum',
        field: 'dental_vaccum',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'dental_vaccum'
    },
    {
        headerName: 'Medical Gas',
        field: 'medical_gas',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'medical_gas'
    },
    {
        headerName: 'Drain',
        field: 'drain',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'drain'
    },
    {
        headerName: 'Drain Location',
        field: 'drain_location',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'drain_location'
    },
    {
        headerName: 'Gas Type',
        field: 'gas_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'gas_type'
    },
    {
        headerName: 'Gas Location',
        field: 'gas_location',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'gas_location'
    },
    {
        headerName: 'Plumbing Remarks',
        field: 'plumbing_remarks',
        minWidth: 200,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plumbing_remarks'
    },
    {
        headerName: 'Vent',
        field: 'mechanical_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'vent'
    },
    {
        headerName: 'Vent Type',
        field: 'vent_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'vent_type'
    },
    {
        headerName: 'Heat Dissipation (BTU/hr)',
        field: 'heat_hr',
        minWidth: 200,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'heat_hr'
    },
    {
        headerName: 'Dissipation Type',
        field: 'dissipation_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'dissipation_type'
    },
    {
        headerName: 'Mechanical Remarks',
        field: 'mechanical_remarks',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'mechanical_remarks'
    },
    {
        headerName: 'Product Specification',
        field: 'specifications_doc',
        minWidth: 160,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Product Brochure',
        field: 'brochure_doc',
        minWidth: 160,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Product Site-Planning',
        field: 'site_planning_doc',
        minWidth: 160,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Product Operating Manual',
        field: 'operating_manual_doc',
        minWidth: 160,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'URL',
        field: 'website_url',
        minWidth: 300,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: '2D',
        field: 'twod_doc',
        minWidth: 60,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: '3D',
        field: 'threed_doc',
        minWidth: 60,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Other Document',
        field: 'documents',
        minWidth: 160,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
];

export const SupplierColDef = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        flex: 1,
        minWidth: 40,
    },
    {
        headerName: 'Product Provider ID',
        field: 'product_provider_id',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        flex: 1,
        minWidth: 100,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Name',
        field: 'name',
        minWidth: 250,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Manufacturer',
        field: 'manufacturer',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Vendor',
        field: 'vendor',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Organization Vendor',
        field: 'org_vendor',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Email',
        field: 'email',
        minWidth: 250,
        hide: false,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Contact No',
        field: 'contactno',
        minWidth: 150,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Website',
        field: 'website',
        minWidth: 310,
        hide: false,
        filter: false,
        sortable: false,
        resizable: true
    },
];